import React from 'react';
import { OutliersBenchmarkType } from 'widgets/outliers/store/config/OutliersConfigState';
import { DropdownItemProps } from '@instinet-analytics/semantic-ui-components';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';

export interface OutliersBenchmarkTypeDropdownProps {
    value?: OutliersBenchmarkType;
    onChange: (nextValue: OutliersBenchmarkType | undefined) => void;
}

export function OutliersBenchmarkTypeDropdown(
    props: OutliersBenchmarkTypeDropdownProps
) {
    const { value, onChange } = props;

    const options: DropdownItemProps[] = [
        { value: 'arrivalPrice', key: 'arrivalPrice', text: 'Arrival Price' },
        {
            value: 'adjustedArrivalPrice',
            key: 'adjustedArrivalPrice',
            text: 'Adjusted Arrival Price',
        },
    ];

    const onDropdownChange = (value: string | undefined) => {
        onChange(value as OutliersBenchmarkType);
    };

    return (
        <Dropdown
            className="OutliersBenchmarkTypeDropdown"
            options={options}
            value={value}
            onChange={onDropdownChange}
        />
    );
}
